import { 
  CheckCircleIcon, 
  ExclamationCircleIcon, 
  InformationCircleIcon, 
  XCircleIcon 
} from '@heroicons/react/24/outline'

import PropTypes from 'prop-types'

const defaults = {
  info: {
    container: "bg-blue-500 dark:bg-content2",
    heroIcon: InformationCircleIcon,
    icon: 'text-white dark:text-content2-foreground',
    title: 'text-white dark:text-gray-200',
    description: 'text-white dark:text-content2-foreground',
  },
  
  success: {
    container: "bg-green-500 dark:bg-content2",
    heroIcon: CheckCircleIcon,
    icon: 'text-white dark:text-green-500',
    title: 'text-white dark:text-green-500',
    description: 'text-white dark:text-green-500',
  },
  
  warning: {
    container: "bg-orange-500 dark:bg-content2",
    heroIcon: ExclamationCircleIcon,
    icon: 'text-white dark:text-yellow-500',
    title: 'text-white dark:text-yellow-500',
    description: 'text-white dark:text-yellow-500',
  },

  danger: {
    container: "bg-red-500 dark:bg-content2",
    heroIcon: XCircleIcon,
    icon: 'text-white dark:text-red-500',
    title: 'text-white dark:text-red-500',
    description: 'text-white dark:text-red-500',
  },
}

const Alert = ({ classNames, description, rightContent = null, title, type }) => {
  const { heroIcon: HeroIcon, icon: iconStyles, title: titleStyles, description: descriptionStyles, container: containerStyles } = defaults[type];

  return (
    <div className={`rounded-md p-4 ${containerStyles} ${classNames}`}>
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <HeroIcon className={`h-14 w-14 mr-2 ${iconStyles}`} aria-hidden="true" />
        </div>
  
        <div className="flex items-center justify-between w-full gap-4">
          <div className="w-full">
            <h3 className={`text-md mb-1 font-semibold leading-tight ${titleStyles}`}>{title}</h3>
            <div className={`text-sm ${descriptionStyles}`}>
              <p>{description}</p>
            </div>
          </div>

          <div>
            {rightContent}
          </div>
        </div>
      </div>
    </div>
  )
}

Alert.propTypes = {
  classNames: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired,
  rightContent: PropTypes.node,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['info', 'success', 'warning', 'danger']).isRequired
}

export default Alert